<span id="standing-authorizations-form-header" class="section-title">{{standingAuthFormHeader}}</span><br>
<div class='errorMsgContainer' *ngIf="ineligibleRegTypeForStandingAuthorization">
    <span class="main-msg">
        <div class='documentWarning-icon'></div>
        <span>Standing authorizations cannot be created online for this account type.</span>
        <span class="secondary-msg">Download the standing authorization form in <a (click)="getAccManagementRedirect()" id="fna-download">Account Management.</a></span>    
    </span>
</div>
<mm-banners *ngIf="showCreateRequestAccessDeniedAlert" [bannerText]="[createRequestAccessDeniedText]" 
    [type]="'information'" data-testid="access-denied-banner">
</mm-banners>
<mm-banners *ngIf="isPalAccount" [bannerText]="[palAccountNotSupportedErrorText]"
            [type]="'error'" data-testid="pal-account-access-denied-banner">
</mm-banners>
<div *ngIf="(hasMoveMoneyDataAccess || isEmployee) && isValidRegType && !hasHeaderStateError 
    && !ineligibleRegTypeForStandingAuthorization && !isPalAccount">
    <form [formGroup]="standingAuthorizationsForm" id="create-standing-auth-form-container"
        data-testid="createStandingAuthForm">
        <mm-spinner [loading]="formSpinnerState$" [makeInert]="false"></mm-spinner>
        <mm-banners *ngIf="showDigitalToPdfIneligibleBanner" [bannerText]="[digitalToPdfIneligibleText]"
            [type]="'warning'"></mm-banners>
        <mm-banners *ngIf="serviceError?.hasError" [serviceError]="(standingAuthFormServiceError$ | async)!"
            [type]="'error'">
        </mm-banners>
        <mm-banners *ngIf="hasATSSystemError" [bannerText]="[atsSystemErrorText]" [type]="'error'"></mm-banners>
        <mm-view-move-money-page *ngIf="isBtMasterOnly"></mm-view-move-money-page>
        <div id="standing-authorization-transaction-type-selection" class="big-bottom-spacer">
            <mm-radio-control *ngIf="transactionTypeControl?.radios?.length" [parentForm]="standingAuthorizationsForm"
                [radioModel]="transactionTypeControl" class="big-bottom-spacer"></mm-radio-control>
        </div>

        <mm-sa-bundled-toggle *ngIf="showBundledToggle" [parentForm]="standingAuthorizationsForm"
            data-testid="create-bundled-sa-section">
        </mm-sa-bundled-toggle>

        <div [ngSwitch]="transactionType">
            <div *ngSwitchCase="'ach'">
                <div class="big-top-spacer">
                    <mm-sa-ach-extra-prompts *ngIf="displayAchForm" [parentForm]="standingAuthorizationsForm"
                        [prefilledPrompts]="$any(prefilledForm?.extraPrompts)"
                        [prefilledPromptsObs]="$any(prefilledPromptsObsExtra).asObservable()!"
                        (extraPromptsComplete)="onExtrasCompleted($event)" [isFromEditSubmittedStandingAuth]="true">
                    </mm-sa-ach-extra-prompts>
                    <div *ngIf="displayAchForm">
                        <mm-standing-authorization-details-ach [parentForm]="standingAuthorizationsForm"
                            [prefilledPrompts]="$any(prefilledForm?.standingAuthorizationDetails)">
                        </mm-standing-authorization-details-ach>
                    </div>
                </div>
            </div>
            <div *ngSwitchCase="'check'">
                <mm-standing-authorization-details-check *ngIf="displayCheckForm"
                    [parentForm]="standingAuthorizationsForm"
                    [prefilledPromptsObs]="$any(prefilledPromptsObs).asObservable()!">
                </mm-standing-authorization-details-check>
            </div>
            <div *ngSwitchCase="'wire'">
                <mm-standing-authorization-details-wire *ngIf="(readyForWireStandingAuthDetails$ | async)"
                    [parentForm]="standingAuthorizationsForm"
                    [prefilledPromptsObs]="$any(prefilledPromptsObs).asObservable()!">
                </mm-standing-authorization-details-wire>
            </div>
            <div *ngSwitchCase="'internal-transfer'">
                <mm-standing-authorization-details-internal-transfers [parentForm]="standingAuthorizationsForm"
                    [prefilledPromptsObs]="$any(prefilledPromptsObs).asObservable()!"></mm-standing-authorization-details-internal-transfers>
            </div>
        </div>

        <sdps-divider variation="secondary" class="sdps-m-vertical_medium"></sdps-divider>
        <div id="button-container">
            
            <button id="transactionFormPage_cancelButton" data-testid="transactionFormPage_cancelButton"
             id="createStandingAuthFormPage_cancelButton" (click)="onCancelClick()" type="button"
                class="sdps-button sdps-button--small sdps-button--secondary">Cancel</button>
                
            <button id="transactionFormPage_continueButton" data-testid="transactionFormPage_continueButton"
             id="createStandingAuthFormPage_continueButton"
                data-testid="createStandingAuthFormPage_continueButton" (click)="onContinueClick()" type="submit"
                class="sdps-button sdps-button--primary sdps-button--small">Continue</button>
        </div>
    </form>
    <mm-twe-modal [showModal]="showTweModal" [upcomingTransactions$]="tweUpcomingTransactions$"
        [sloas$]="tweStandingAuth$" [recurringTransactions$]="tweRecurringTransactions$"
        [taxWithholdings$]="taxWithholdings$" [tweTableState$]="tweTableState$"></mm-twe-modal>
</div>